/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.3.0-nightly.2026.5.20",
    versionName: "0.3.0-nightly.2026.5.20",
    versionChannel: "nightly",
    buildDate: "2026-05-20T00:37:51.253Z",
    commitHash: "e378d601987bcdc31e1e6cc208cc6f2ec89b4a66",
};
